<template>
  <div class="play-view-pay">
    <button class="buy" @click="showPayHandle">
      <template v-if="album.cost">
        整册特惠<span class="price">{{ album.cost | money }}元</span>
        <span v-show="album.costprice != album.cost" class="old_price">¥{{ album.costprice | money }}</span>
      </template>
    </button>
    <Teleport to="album-detail" class="paytype-popup">
      <popup v-model="showPayInfo">
        <div class="popup-content">
          <!-- <div class="popup-desc">支付{{ album.cost | money }}元</div> -->
          <template v-if="!isWxWeb">
            <div>
              <label for="wechat" class="popup-item">
                <img src="@/assets/icon_wechat.png">
                <span style="flex:1">微信支付</span>
                <input id="wechat" type="radio" name="paytype" value="1" v-model="payMethod">
              </label>
            </div>
            <div>
              <label for="alipay" class="popup-item">
                <img src="@/assets/icon_alipay.png">
                <span style="flex:1">支付宝支付</span>
                <input id="alipay" type="radio" name="paytype" value="0" v-model="payMethod">
              </label>
            </div>
          </template>
          <template v-else>
            <div>
              <label for="wechat" class="popup-item">
                <img src="@/assets/icon_wechat.png">
                <span style="flex:1">微信支付</span>
                <input id="wechat" type="radio" name="paytype" value="2" v-model="payMethod">
              </label>
            </div>
          </template>
          <div v-show="deduct.length > 0">
            <label for="deduct" class="popup-item">
              <img src="@/assets/icon_coupon.png">
              <span style="flex:1">优惠劵抵扣0元</span>
              <input id="deduct" type="radio" name="paytype" value="-1" v-model="payMethod">
            </label>
          </div>
          <div v-show="coupons.list.length > 0">
            <div for="coupon" class="popup-item coupon" @click="showCoupon=!showCoupon">
              <img src="@/assets/redbag-icon.png" alt="">
              <span>优惠劵</span>
              <span class="coupon-info">-{{ coupons.coupon | money }}</span>
              <input type="checkbox" name="coupon" id="coupon" v-model="useCoupon" @click.stop="">
            </div>
            <div class="coupon-container" v-show="showCoupon">
              <div v-for="(item, key) in coupons.list" :key="key" class="coupon-item">{{ item.title }}</div>
            </div>
          </div>
          <button @click="tpay">确认支付</button>
        </div>
      </popup>
    </Teleport>
  </div>
</template>

<script>
import { Popup, Toast } from 'mint-ui';
import { paying } from '@/utils/pay'
import { pay, ready } from '@/api/pay'
import { isWeiXin } from '@/utils/index'
import { canUseCoupons, useCoupons } from '@/api/coupon'
import { money, analogJump } from '@/utils/index'
import { umtrack } from '@/utils/uweb'
import Teleport from '@/components/teleport/index'
export default {
  name: 'PlayViewPay',
  components: {Popup, Teleport},
  filters: {
    money
  },
  props: {
    album: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data () {
    return {
      showPayInfo: false,
      payMethod: 1,
      coupons: {coupon: 0, list: []},
      deduct: [],
      useCoupon: true,
      showCoupon: false,
      isWxWeb: false,
      defaultMethod: 1,

      ispaying: false,
      timer: null
    }
  },
  created () {
    this.isWxWeb = isWeiXin()
    this.payReady()
    if(this.isWxWeb){
      this.defaultMethod = 2
    }
    this.payMethod = this.defaultMethod
  },
  methods: {
    payReady() {
      if(!this.isWxWeb){
        return
      }
      ready({method: 2, redirect: window.location.href}).catch(error=>{
        window.location.replace(error.data)
      })
    },
    showPayHandle() {
      umtrack('pay', {id: this.album.id, title: this.album.album_title}, this)
      this.getCoupons()
      this.showPayInfo = true
    },
    getCoupons() {
      canUseCoupons({id: this.album.id, price: this.album.cost}).then((response) => {
        var {deduct, coupon} = response.data.data
        this.coupons = coupon
        this.deduct = deduct
      })
    },
    tpay(){
      if(this.ispaying) {
        Toast({
          message: "正在支付请稍后",
          position: 'bottom',
          duration: 1000
        })
        return
      }
      this.ispaying = true
      this.clearStatus()
      var params = {
        price: this.album.cost,
        title: this.album.album_title,
        source: this.album.id,
        sign: this.album.sign,
        method: this.payMethod,
        type: this.album.album_type
      }
      // 优惠劵抵扣
      if(this.payMethod == -1){
        this.payMethod = this.defaultMethod
        this.couponUse(params)
        return
      }
      if(this.useCoupon&&this.coupons.list.length > 0){
        params['coupon'] = this.coupons.list.map((value,index,array)=>{
          return value.id
        }).join(',');
      }
      // 支付
      pay(params).then((response)=>{
        var data = response.data.data
        this.showPayInfo = false
        paying(this.payMethod, data.url, data.return_url).then( url => {
          analogJump(url, '', false)
        })
      }).catch((error)=>{
        this.showPayInfo = false
        if(error.message != 'Error'){
          this.$router.push({path: '/login', query: { scene: error.message==311?'bind':'login', redirect: this.$route.fullPath}})
        }
      })
    },
    couponUse(params){
      this.showPayInfo = false
      params['coupon'] = this.deduct[0].id
      useCoupons(params).then((response) => {
        Toast({
          message: "成功",
          position: 'bottom',
          duration: 1000
        })
        window.location.reload()
      })
    },
    clearStatus(){
      if(this.timer){
        window.clearTimeout(this.timer)
      }
      this.timer = window.setTimeout(() => {
        this.ispaying = false;
      },5000);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.play-view-pay{
  button{
    border:none;
    width: 100%;
    text-align: center;
    // background:linear-gradient(135deg,rgba(255,101,64,1) 0%,rgba(255,90,67,1) 100%);
    padding: 10px 0;
    border-radius: 6px;
    &.buy{
      // background-color: rgb(245, 121, 19);
      background-color: #FF6767;
      color: #fff;
      font-size: 20px;
      .price{
        margin: 0 3px;
      }
      .old_price{
        margin-left: 10px;
        font-size: 14px;
        text-decoration:line-through;
      }
    }
  }
}
</style>
<style lang="scss">
.paytype-popup{
  .popup-content{
    padding: 16px 0;
    width: 70vw;
    text-align: left;
    .popup-desc{
      font-size: 20px;
    }
    .popup-item{
      display: flex;
      align-items: center;
      padding: 6px 0;
      border-bottom: #eee solid 1px;
      margin: 10px 16px;
      font-size: 18px;
      img{
        width: 20px;
        margin-right: 6px;
      }
    }
    .popup-item:last-child{
      border-bottom: none;
      margin-bottom: 0;
    }
    .coupon{
      background-color: #FFEFDA;
      border-bottom: none;
      margin: 0;
      padding: 13px 16px ;
      span.coupon-info{
        flex: 1;
        text-align: right;
        color: rgb(248, 38, 38);
        padding-right: 13px;
      }
    }
    .coupon-container{
      box-shadow: inset 0 15px 15px -15px rgb(155, 155, 155), inset 0 -15px 15px -15px rgb(155, 155, 155);
      padding: 13px 0;
      .coupon-item{
        margin-left: 16px;
        padding: 6px 16px 6px 0;
        border-bottom: rgb(202, 202, 202) 1px solid;
      }
    }
    button{
      display: block;
      border: none;
      background-color: rgb(245, 121, 19);
      width: 90%;
      color: #eee;
      border-radius: 6px;
      padding: 10px;
      font-size: 16px;
      margin: 0 auto;
      margin-top: 13px;
    }
  }
}
</style>